enum InputType {
  PASSWORD = 'password',
  TEXT = 'text',
}

export default function hideShowPassword(inputType: string): InputType {
  return inputType === InputType.PASSWORD ? InputType.TEXT : InputType.PASSWORD;
}
